<template>
    <b-card class="worker-relais-home-body-activity-card">
        <div class="row activity-card-row">
            <div
                    class="col-8 activity-card-col"
                    @click="goToMeeting()"
            >
                <h3>{{name}}</h3>
                <p>{{date.calendar()}} à {{date.format('HH[h]')}}</p>
                <p class="text-muted">{{type}}</p>
            </div>
            <div class="col-4 activity-card-col">
                <p class="text-number">
                    <i class="fas fa-users"></i>
                    {{meeting.reservations.length}} / {{meeting.capacity}}
                    <span
                            class="list-group-trigger"
                            @click="listGroupModal = !listGroupModal"
                    >
                        <i class="far fa-eye"></i>
                    </span>
                    <b-modal
                            v-model="listGroupModal"
                            body-class="list-group-modal"
                            centered
                            scrollable
                            hide-header
                            hide-footer
                            ref="meeting-reservations-modal"
                    >
                        <div class="row list-group-top-modal">
                            <div class="col-11 list-group-top-modal-col">
                                <h1>
                                    <i class="far fa-eye"></i>
                                    Liste des inscrits
                                </h1>
                            </div>
                            <div class="col-1 list-group-top-modal-col">
                                <i
                                        class="fas fa-times close-modal"
                                        @click="listGroupModal = !listGroupModal"
                                ></i>
                            </div>
                        </div>

                        <div class="list-group-modal-list">
                            <b-card
                                    v-for="(reservation, index) of meeting.reservations"
                                    :key="`meeting-reservation-${index}`"
                                    class="modal-list-card"
                            >
                                <h2>
                                    <i class="fas fa-user-circle"></i>
                                    {{$store.getters['base/account/getFullName'](reservation.user)}}
                                    <span>{{meeting.activite.ou.fullName}}</span>
                                </h2>
                            </b-card>
                        </div>
                    </b-modal>

                </p>
                <b-btn
                        v-if="meeting['canCreateReservation']"
                        class="activity-card-btn"
                        @click.once="register()"
                >
                    Rejoindre
                </b-btn>
                <b-btn
                        v-else-if="meeting['hasReservation']"
                        class="activity-card-btn"
                >
                    <i class="fas fa-check"/> Inscrit
                </b-btn>
            </div>
        </div>
    </b-card>
</template>

<style lang="scss" scoped>
    .worker-relais-home-body-activity-card{
        .card-body{
            padding: 0.2em !important;
        }
    }
    @media screen and (min-width: 667px) {
        .worker-relais-home-body-activity-card{
            width: 97.5%;
            padding-right: 0.3em;
        }
    }
</style>

<script>
    import moment from 'moment'

    export default {
        name: 'home-bottom-meeting',
        props: {
            meeting: Object
        },
        data: () => ({
            moment,
            listGroupModal: false,
        }),
        computed: {
            date() {
                return moment(this.meeting.dateheure.date)
            },
            name() {
                return [this.meeting.activite.typeactivite.name, this.meeting.activite.name, this.meeting.name].join(' ')
            },
            type() {
                if (this.meeting.isPrivate) {
                    if (this.meeting.activite.private) {
                        return 'Séance spontanée privée'
                    } else {
                        return 'Séance sportive privée'
                    }
                } else {
                    if (this.meeting.activite.private) {
                        return 'Séance spontanée publique'
                    } else {
                        return 'Séance sportive publique'
                    }
                }
            }
        },
        methods: {
            goToMeeting(){
                this.$router.push({
                    name: 'meeting',
                    params: {
                        id: this.meeting.id
                    }
                })
            },
            async register() {
                await this.$store.dispatch('base/meeting/reservation/create', {
                    meetingId: this.meeting.id
                })
                await this.$store.dispatch('base/appInterface/home')
            }
        }
    }
</script>
